export const ROLE_ADMIN = 'admin'
export const ROLE_CERTIFICATION_MANAGER = 'certification manager'
